export default __webpack_public_path__ + "static/media/a3.0fb20721.png";